const comments = [
  {
    name: '电影发烧友小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20man%20with%20warm%20lighting%2C%20simple%20neutral%20background%2C%20friendly%20expression%2C%20headshot%20style&width=120&height=120&seq=avatar-cmt-01&orientation=squarish',
    text: '用了91免费快半年了，资源更新真的快！院线新片下映后基本一周内就能在这里找到。片库也很全，从国产剧到欧美大片都有，最关键是全程没广告弹窗，观影体验比那些盗版站好太多了。',
    time: '3天前',
    rate: 5,
  },
  {
    name: '追剧少女小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20woman%20with%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20friendly%20smile%2C%20headshot%20style%20photography&width=120&height=120&seq=avatar-cmt-02&orientation=squarish',
    text: '之前一直到处找免费电影资源，不是画质糊就是链接失效。91免费的多线路切换功能太贴心了，某条线路卡了直接切另一条就好。移动端看也很方便，午休摸鱼必备！',
    time: '1周前',
    rate: 5,
  },
  {
    name: '老影迷李叔',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20middle-aged%20Chinese%20man%20with%20warm%20studio%20lighting%2C%20simple%20background%2C%20calm%20expression%2C%20headshot%20style&width=120&height=120&seq=avatar-cmt-03&orientation=squarish',
    text: '作为一个看了30年电影的老影迷，最欣赏91免费的是他们的专题策划。不是简单堆资源，而是真的在用心做内容推荐。经典重温那个专题让我发现了不少遗漏的好片，周末泡杯茶慢慢看，享受。',
    time: '2周前',
    rate: 4,
  },
  {
    name: '学生党阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Asian%20student%20male%20with%20warm%20lighting%2C%20simple%20background%2C%20casual%20friendly%20look%2C%20headshot%20style&width=120&height=120&seq=avatar-cmt-04&orientation=squarish',
    text: '学生党预算有限，91免费简直是救星！1080P高清还免费，宿舍用电脑投屏到电视上效果也很棒。室友也被我安利了，现在我们宿舍的周末固定节目就是一起刷91免费上的电影。',
    time: '3周前',
    rate: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-4 whitespace-nowrap">
            用户评价
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            影迷评论
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            听听用户们怎么说，真实观影反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="rounded-2xl bg-background-100 border border-background-200/60 p-6 md:p-7"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-heading text-base font-bold text-foreground-900">
                      {comment.name}
                    </h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap ml-2">{comment.time}</span>
                  </div>
                  <div className="flex gap-0.5 mb-3">
                    {Array.from({ length: comment.rate }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {comment.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}